// StripeAccount.jsx
import { useEffect } from "react";
import axios from "axios";
import config from "../../../../../config.json";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { userProfile } from "../../../../services/AuthService";

const StripeAccount = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const openStripeDashboard = async () => {
      try {
        const userData = await userProfile();
        console.log("userData", userData.restaurantFK);

        const response = await axios.get(
          `${config.dev}/v2/restaurant/stripe/dashboard/${userData.restaurantFK}`
        );
        window.open(response.data.url, "_blank");
        toast.success("Opening a Stripe account...");
        navigate("/app-profile");
      } catch (error) {
        toast.error("Unable to access Stripe account.");
        navigate("/app-profile");
      }
    };

    openStripeDashboard();
  }, []);

  return (
    <div className="text-center mt-5">
      <h4>Redirecting to your Stripe dashboard...</h4>
    </div>
  );
};

export default StripeAccount;
